import { Button, Modal, ModalBody, FormGroup, Label, Input } from 'reactstrap';
import { TextInput } from '~/shared/components/form/Inputs';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { submitForAppeal } from '~/services/fundrequests';
import { useContext } from 'react';
import { FundRequestContext } from '~/context/fundrequests';
import { AdminContext } from '~/context/admin';
import toast from 'react-hot-toast';

export type SubmitForAppealModalProps = {
    isOpen: Boolean;
    toggle: () => void;
};

export const SubmitForAppealModal = (props: SubmitForAppealModalProps) => {
    const [{ fundRequest }, fundRequestDispatch] =
        useContext(FundRequestContext);
    const [{ campaignId }, adminDispatch] = useContext(AdminContext);
    const { isOpen, toggle } = props;
    const history = useHistory();
    const {
        register,
        handleSubmit,
        watch,
        errors,
        control,
        reset,
        setValue,
        getValues,
        formState: { isSubmitting, isValid },
    } = useForm({
        mode: 'onBlur',
        defaultValues: {
            plea: '',
        },
    });

    const handleSave = async (data) => {
        try {
            const resp = await submitForAppeal(
                fundRequest.id,
                data,
                campaignId
            );
            toast.success('Appeal submitted successfully');
            history.push(`/requests`);
        } catch (error) {
            console.error(error);
            toast.error('Failed to submit appeal');
        }
    };

    return (
        <Modal centered isOpen={isOpen} toggle={toggle}>
            <ModalBody>
                <h3>Submit for Appeal</h3>
                <p>
                    Please provide a <strong>brief</strong> explanation to the
                    Grant Committee as to why we should make an exception for
                    this request.
                </p>
                <TextInput
                    name='plea'
                    label='Plea'
                    type='textarea'
                    size='sm'
                    required={true}
                    ariaRequired={true}
                    control={control}
                />
                <Button
                    color='outline-dark'
                    onClick={toggle}
                    disabled={isSubmitting}
                >
                    Cancel
                </Button>
                <Button
                    color='primary'
                    onClick={() => handleSubmit(handleSave)()}
                    disabled={!isValid || isSubmitting}
                >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>
            </ModalBody>
        </Modal>
    );
};
